<template>
  <div class="topVert" id="panneauxLc"
       v-if="detailPanneauxLcFilter.length">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold has-text-link bottomBleu">
        Proposition face(s) LC
      </h2>
    </div>
    <div class="bottom">
      <app-carte-panneaux-lc :markers="detailPanneauxLcFilter" :markerFaceLc="markerFaceLc"/>
    </div>
    <h3 class="has-text-weight-bold has-text-link bottomViolet topRouge">Liste face(s) LC</h3>
    <app-listes-faces-lc :detailPanneauxLc="detailPanneauxLcFilter"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import cartePanneauxLc from './cartePanneauxLc';
import listesFacesLc from './listesFacesLc';

export default {
  name: 'index',
  props: ['detailPanneauxLc', 'adresseFaceLc'],
  components: {
    appCartePanneauxLc: cartePanneauxLc,
    appListesFacesLc: listesFacesLc,
  },
  data() {
    return {
      markerFaceLc: {},
    };
  },
  computed: {
    ...mapGetters(['getMaSelection']),
    detailPanneauxLcFilter() {
      const data = this.detailPanneauxLc.filter(d => !d.extensionOpportunite.reseauPersoGuid);
      if (this.getMaSelection) {
        return data.filter(el => el.select);
      }
      return data;
    },
  },
  methods: {
    generateMarkerFaceLc() {
      if (this.adresseFaceLc.lat !== undefined) {
        this.markerFaceLc = {
          ...this.adresseFaceLc,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarkerFaceLc();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxLc/index.vue